import { DeliveryOptionType } from "@jti/store";
export const getDeliveryOptionType = (deliveryOption) => {
    const optionTypeMatchingMap = {
        [DeliveryOptionType.CustomDeliveryOption]: deliveryOption?.widgetTagName && deliveryOption.widgetUrl,
        [DeliveryOptionType.InStoreJti]: deliveryOption?.flotiqApiKey,
    };
    const deliveryOptionType = Object.keys(optionTypeMatchingMap).find((key) => optionTypeMatchingMap[key]);
    return deliveryOptionType ?? DeliveryOptionType.AtHome;
};
export const getCurrentDeliveryOptionType = (deliveryOptions, methodCode) => {
    const selectedDeliveryOption = deliveryOptions.find((option) => option.methodCode === methodCode);
    if (!selectedDeliveryOption) {
        return DeliveryOptionType.AtHome;
    }
    return getDeliveryOptionType(selectedDeliveryOption);
};
//# sourceMappingURL=getCurrentDeliveryOptionType.js.map